import { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL, DEFAULT_HEADERS } from "../apiConfig";

export const useFloors = (typeId) => {
  const [floors, setFloors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFloors = async () => {
      if (!typeId) return;
      
      try {
        setLoading(true);
        const response = await axios.get(`${BASE_URL}/types/${typeId}/floors`, {
          headers: DEFAULT_HEADERS,
        });
        // افترضنا هنا أن البيانات تأتي في response.data
        setFloors(response.data); 
      } catch (err) {
        console.error("Error fetching floors:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchFloors();
  }, [typeId]); // سيعيد التنفيذ إذا تغير رقم النوع

  return { floors, loading, error };
};